var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.58862 0 0 3.58862 0 8C0 12.4114 3.58862 16 8 16C12.4114 16 16 12.4114 16 8C16 3.58862 12.4114 0 8 0Z",
    fill: "#ed6265"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99 8.00019L10.8462 6.14401C11.0513 5.93892 11.0513 5.60642 10.8462 5.40165L10.5987 5.1542C10.3936 4.94905 10.0611 4.94905 9.85631 5.1542L8.00019 7.01032L6.14401 5.15382C5.93892 4.94873 5.60642 4.94873 5.40165 5.15382L5.15382 5.40127C4.94873 5.60642 4.94873 5.93892 5.15382 6.14369L7.01032 8.00019L5.1542 9.85631C4.94905 10.0615 4.94905 10.394 5.1542 10.5987L5.40165 10.8462C5.60674 11.0513 5.93924 11.0513 6.14401 10.8462L8.00019 8.99L9.85631 10.8462C10.0615 11.0513 10.394 11.0513 10.5987 10.8462L10.8462 10.5987C11.0513 10.3936 11.0513 10.0611 10.8462 9.85631L8.99 8.00019Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconError);
export default __webpack_public_path__ + "static/media/icon_error.b6d31914.svg";
export { ForwardRef as ReactComponent };